import Axios from 'axios';
import router from '../router';

const reg = /\/user\/jwt\/time|\/user\/jwt\/token|api\/v1\/layers|api\/v1\/files\/FileDetails|\/datamanager\/api\/v1\/iconImage|\/tilecache/;



let service = Axios.create({
    // 设置超时时间
    timeout: 600000,
    baseURL:`/beidouApi`
});

// post请求的时候，我们需要加上一个请求头，所以可以在这里进行一个默认的设置
// 即设置post的请求头为application/x-www-form-urlencoded;charset=UTF-8
// service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

//请求拦截
service.interceptors.request.use(
    function (config) {
        if (
            !config.headers.token &&
            localStorage.getItem('token') &&
            localStorage.getItem('token') !== 'undefined'
        ) {
            config.headers.token = localStorage.getItem('token');
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// http response 拦截器
service.interceptors.response.use(
    response => {
        if (response && response.data && response.data.description === '征用模式') {
            alert('当前为征用模式，该系统将暂停使用，请稍后再试');
            throw SyntaxError();
        } else {
            return response;
        }
    },
    error => {
        if (error.response) {

            switch (error.response.status) {
                case 401:
                    // 返回 401 清除token信息并跳转到登录页面
                    localStorage.setItem('token', undefined);
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        },
                    });
                    return error;
                case 404:
                    alert('服务器连接异常');
                    return;
                case 500:
                case 400:
                    return error.response;

              
            }

        }

        if (/Network/g.test(error.message)) {
            Elmessage.error({
                message: '网络异常，请检查网络连接是否正常',
            });
        } else if (/timeout/g.test(error.message)) {
            Elmessage.error({
                message: '请求超时，请检查服务器连接是否正常',
            });
        }
    }
);

export default service;